export default __webpack_public_path__ + "static/media/redirect-card-sk.117b4537.png";